import { render, staticRenderFns } from "./WelcomeSetting.vue?vue&type=template&id=41b81cc8"
import script from "./WelcomeSetting.vue?vue&type=script&lang=js"
export * from "./WelcomeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports